// extracted by mini-css-extract-plugin
export default {"body":"FailPayment_body__2gu4L","center":"FailPayment_center__pfHed","wa":"FailPayment_wa__-93eI","wa__icon":"FailPayment_wa__icon__RT46b"};